import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDeviceSignalTagsDocument } from './update.generated';

export const useUpdateDeviceSignalTags = (
  options: ApiOptions<typeof UpdateDeviceSignalTagsDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateDeviceSignalTagsDocument, {
    ...useNotifications(UpdateDeviceSignalTagsDocument, {
      failure: t('api.device_signal_tags.update_error'),
      success: t('api.device_signal_tags.update_success'),
    }),
    ...options,
  });
};
